class CanceledError extends Error {
  constructor(message) {
    super(message);
    this.name = 'CanceledError';
  }
}
export default CanceledError;
